import { render, staticRenderFns } from "./OaForm.vue?vue&type=template&id=6f9bd2a0&"
import script from "./OaForm.vue?vue&type=script&lang=js&"
export * from "./OaForm.vue?vue&type=script&lang=js&"
import style0 from "./OaForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports